
import { Component, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";

@Component({
  name: "callback_page",
  components: {},
})
export default class CallbackPage extends Vue {
  @Getter("getCurrentLocation") currentLocation!: string;
  @Action("completeLogin") completeLogin!: () => Promise<void>;
  hasError = false;
  accessDenied = false;

  constructor() {
    super();
  }

  get currentPath(): string {
    if (!this.currentLocation) {
      return "/";
    }
    const url = new URL(this.currentLocation);
    return `${url.pathname}${url.search}`;
  }

  mounted(): void {
    this.completeLogin()
      .then(() => {
        this.goToCurrentPath();
      })
      .catch(() => {
        if (this.$route.query.error === "access_denied") {
          this.accessDenied = true;
        } else {
          this.hasError = true;
        }
      });
  }

  silentLogout(): void {
    const singOutPopup = window.open(
      this.$services.auth.getLogoutUri(),
      "logout",
      "width=300,height=400,menubar=no, toolbar=no, resizable=no, scrollbars=no"
    );

    setTimeout(() => {
      singOutPopup?.close();

      this.goToCurrentPath();
    }, 150);
  }

  goToCurrentPath(): void {
    this.$router.push({
      path: this.currentPath,
    });
  }
}
